import { Location } from '../types';
import { getDynamicIcon } from './mapIcons';

export const locations: Location[] = [
  {
    id: "cegep",
    name: "Cégep de Saint-Jérôme",
    position: [45.779226174715745, -74.0003602738837],
    icon: getDynamicIcon(1),
    tracks: [
      {
        id: "cegep",
        title: "Cégep de Saint-Jérôme",
        seriousAudioUrl: "cegep-serious.mp3",
        slangAudioUrl: "cegep-slang.mp3",
      },
    ]
  },
  {
    id: "cathedrale",
    name: "Cathédrale de Saint-Jérôme",
    position: [45.77797770977657, -74.00227399640858],
    icon: getDynamicIcon(3),
    tracks: [
      {
        id: "cathedrale",
        title: "Cathédrale de Saint-Jérôme (1)",
        seriousAudioUrl: "cathedrale-serious.mp3",
        slangAudioUrl: "cathedrale-slang.mp3",
      },
      {
        id: "cathedrale-st-jerome",
        title: "Cathédrale de Saint-Jérôme (2)",
        seriousAudioUrl: "phase2/cathedralestjerome.mp3",
      },
      {
        id: "cathedrale-st-jerome-5",
        title: "Cathédrale de Saint-Jérôme (3)",
        seriousAudioUrl: "phase2/cathedralestjerome5.mp3",
      },
    ]
  },
  {
    id: "maclau",
    name: "Ancien palais de justice",
    position: [45.77876179733642, -74.0031638839789],
    icon: getDynamicIcon(7),
    tracks: [
      {
        id: "maclau",
        title: "Ancien palais de justice (1)",
        seriousAudioUrl: "maclau-serious-1.mp3",
        slangAudioUrl: "maclau-slang-1.mp3",
      },
      {
        id: "maclau-2",
        title: "Ancien palais de justice (2)",
        slangAudioUrl: "maclau-slang-2.mp3",
      },
      {
        id: "maclau-3",
        title: "Ancien palais de justice (3)",
        seriousAudioUrl: "maclau-serious-2.mp3",
      },
      {
        id: "maclau-4",
        title: "Ancien palais de justice (4)",
        seriousAudioUrl: "maclau-serious-3.mp3",
        slangAudioUrl: "maclau-slang-3.mp3",
      },
      {
        id: "maclau-5",
        title: "Ancien palais de justice (5)",
        seriousAudioUrl: "maclau-serious-4.mp3",
        slangAudioUrl: "maclau-slang-4.mp3",
      },
      {
        id: "maclau-phase2",
        title: "Ancien palais de justice (6)",
        seriousAudioUrl: "phase2/maclau.m4a",
      },
      {
        id: "maclau-2-phase2",
        title: "Ancien palais de justice (7)",
        seriousAudioUrl: "phase2/maclau2.mp3",
      },
    ]
  },
  {
    id: "vieille-gare",
    name: "Vieille Gare de Saint-Jérôme",
    position: [45.77692938035731, -74.00047050441614],
    icon: getDynamicIcon(2),
    tracks: [
      {
        id: "vieille-gare",
        title: "Vieille Gare de Saint-Jérôme (1)",
        seriousAudioUrl: "vieille-gare-serious-1.mp3",
        slangAudioUrl: "vieille-gare-slang-1.mp3",
      },
      {
        id: "vieille-gare-2",
        title: "Vieille Gare de Saint-Jérôme (2)",
        seriousAudioUrl: "vieille-gare-serious-2.mp3",
        slangAudioUrl: "vieille-gare-slang-2.mp3",
      },
    ]
  },
  {
    id: "arena-st-antoine",
    name: "Aréna St-Antoine",
    position: [45.7794425, -73.995898],
    icon: getDynamicIcon(1),
    tracks: [
      {
        id: "arena-st-antoine",
        title: "Aréna St-Antoine",
        seriousAudioUrl: "phase2/arenastantoine.mp3",
      },
    ]
  },
  {
    id: "cisss-des-laurentides",
    name: "CISSS des Laurentides",
    position: [45.7648351, -74.0012075],
    icon: getDynamicIcon(1),
    tracks: [
      {
        id: "cisss-des-laurentides",
        title: "CISSS des Laurentides",
        seriousAudioUrl: "phase2/cisssdeslaurentides.mp3",
      },
    ]
  },
  {
    id: "emilien-frenette",
    name: "Émilien Frenette",
    position: [45.7787915, -74.0114215],
    icon: getDynamicIcon(1),
    tracks: [
      {
        id: "emilien-frenette",
        title: "Émilien Frenette",
        seriousAudioUrl: "phase2/emilienfrenette.m4a",
      },
    ]
  },
  {
    id: "hotel-plouffe",
    name: "Hôtel Plouffe",
    position: [45.77590909926293, -74.00153369154329],
    icon: getDynamicIcon(2),
    tracks: [
      {
        id: "hotel-plouffe-1",
        title: "Hôtel Plouffe (1)",
        seriousAudioUrl: "phase2/hotelplouffe1.m4a",
      },
      {
        id: "hotel-plouffe-2",
        title: "Hôtel Plouffe (2)",
        seriousAudioUrl: "phase2/hotelplouffe2.m4a",
      },
    ]
  },
  {
    id: "place-cure-labelle",
    name: "Place du Curé Labelle",
    position: [45.77814443006748, -74.0033884502951],
    icon: getDynamicIcon(3),
    tracks: [
      {
        id: "place-cure-labelle-4",
        title: "Place Curé Labelle (1)",
        seriousAudioUrl: "phase2/placecurelabelle4.mp3",
      },
      {
        id: "place-du-cure-labelle",
        title: "Place du Curé Labelle (2)",
        seriousAudioUrl: "phase2/placeducurelabelle.m4a",
      },
      {
        id: "place-du-cure-labelle-2",
        title: "Place du Curé Labelle (3)",
        seriousAudioUrl: "phase2/placeducurelabelle2.m4a",
      },
      {
        id: "parc-labelle",
        title: "Place du Curé Labelle (4)",
        seriousAudioUrl: "parc-labelle-serious-1.mp3",
        slangAudioUrl: "parc-labelle-slang-1.mp3",
      },
      {
        id: "parc-labelle-2",
        title: "Place du Curé Labelle (5)",
        seriousAudioUrl: "parc-labelle-serious-2.mp3",
        slangAudioUrl: "parc-labelle-slang-2.mp3",
      },
      {
        id: "statue-cure-labelle",
        title: "Statue Curé Labelle",
        seriousAudioUrl: "phase2/statuecurelabelle.mp3",
      },
    ]
  },
  {
    id: "promenade-de-la-riviere-du-nord",
    name: "Promenade de la rivière du Nord",
    position: [45.77898746899532, -74.00470018591892],
    icon: getDynamicIcon(1),
    tracks: [
      {
        id: "promenade-de-la-riviere-du-nord",
        title: "Promenade de la rivière du Nord (1)",
        seriousAudioUrl: "phase2/promenadedelarivièredunord.mp3",
      },
            {
        id: "riviere-du-nord-1",
        title: "Promenade de la rivière du Nord (2)",
        seriousAudioUrl: "phase2/rivieredunord1.m4a",
      },
      {
        id: "riviere-du-nord-2",
        title: "Promenade de la rivière du Nord (3)",
        seriousAudioUrl: "phase2/rivieredunord2.mp3",
      },
      {
        id: "riviere-du-nord-3",
        title: "Promenade de la rivière du Nord (4)",
        seriousAudioUrl: "phase2/rivieredunord3.mp3",
      },
      {
        id: "riviere-du-nord-6",
        title: "Promenade de la rivière du Nord (5)",
        seriousAudioUrl: "phase2/rivieredunord6.m4a",
      },
      {
        id: "riviere-du-nord-3-accent",
        title: "Promenade de la rivière du Nord (6)",
        seriousAudioUrl: "phase2/rivièredunord3.mp3",
      },
            {
        id: "parc-de-la-riviere-du-nord-2",
        title: "Promenade de la rivière du Nord (7)",
        seriousAudioUrl: "phase2/parcdelarivierdunord2.m4a",
      },
      {
        id: "parc-de-la-riviere-du-nord",
        title: "Promenade de la rivière du Nord (8)",
        seriousAudioUrl: "phase2/parcdelarivieredunord.mp3",
      },
    ]
  },
  {
    id: "randolph-pub-ludique-st-jerome",
    name: "Randolph Pub Ludique St-Jérôme",
    position: [45.7773, -74.0041],
    icon: getDynamicIcon(1),
    tracks: [
      {
        id: "randolph-pub-ludique-st-jerome",
        title: "Randolph Pub Ludique St-Jérôme",
        seriousAudioUrl: "phase2/randolphpubludiquestjerome.mp4",
      },
    ]
  },
  {
    id: "tecnic-st-jerome",
    name: "Tecnic St-Jérôme",
    position: [45.78748704478253, -74.00196520998051],
    icon: getDynamicIcon(1),
    tracks: [
      {
        id: "tecnic-st-jerome",
        title: "Tecnic St-Jérôme",
        seriousAudioUrl: "phase2/tecnicstjerome.m4a",
      },
    ]
  },
  {
    id: "theatre-gilles-vigneault",
    name: "Théâtre Gilles Vigneault",
    position: [45.775907824207614, -74.00061958767584],
    icon: getDynamicIcon(1),
    tracks: [
      {
        id: "theatre-gilles-vigneault",
        title: "Théâtre Gilles Vigneault",
        seriousAudioUrl: "phase2/theatregillesvigneault.mp3",
      },
    ]
  },
];
